"use client";

import { useOnlineStatus } from "@/lib/pwa/use-online-status";
import { WifiOffIcon } from "@/components/ui/WifiOffIcon";

export function OfflineSyncBanner() {
  const { isOnline, pendingCount, syncing } = useOnlineStatus();

  if (!isOnline) {
    return (
      <div className="bg-safety-orange/10 border-b-2 border-safety-orange/30 px-4 py-2 flex items-center justify-center gap-2">
        <WifiOffIcon className="text-safety-orange" />
        <p className="font-body text-xs text-border-thick/70">
          <span className="font-semibold">You&apos;re offline</span>
          {pendingCount > 0 && ` — ${pendingCount} study session${pendingCount > 1 ? "s" : ""} will sync when you reconnect`}
        </p>
      </div>
    );
  }

  if (syncing) {
    return (
      <div className="bg-primary/5 border-b-2 border-primary/20 px-4 py-1.5 flex items-center justify-center gap-2">
        <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
        <p className="font-body text-xs text-border-thick/50">Syncing offline study sessions...</p>
      </div>
    );
  }

  return null;
}
